import React from 'react';
import {ImageText, DataRPC} from '../../rpc-client/DataRPC';
import './Footer.css';

class Footer extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            footer: "",
            mail: "",
            sdt: "",
            footer_image: ""
        }
    }

    async componentDidMount() {
        new DataRPC().fetchData('GetImageText', {
            page: "footer"
        }, ImageText).then(gData => { 
            if (gData) {
                this.setState({footer: gData.find(x => x.komoku === "footer_mieuta").content});
                this.setState({mail: gData.find(x => x.komoku === "footer_mail").content});
                this.setState({sdt: gData.find(x => x.komoku === "footer_sdt").content});

                this.setState({footer_image: gData.find(x => x.komoku === "footer_image").content});
            }
        });
    }

    render() {
        return(
            <footer className="hc-footer">
                <div className="hc-container">
                    <div className="hc-footer-grid">
                        <div className="hc-footer-brand">
                            <img src={this.state.footer_image} alt="" className="img-fluid" />
                            <p> {this.state.footer} </p>
                        </div>

                        <div className="hc-footer-widget">
                            <h4>Liên hệ</h4>
                            <div className="hc-divider" style={{margin: '10px 0 4px'}}></div>

                            <div className="hc-footer-contact">
                                <div className="icon"><i className="icofont-email"></i></div>
                                <div>
                                    <span className="label">Email</span>
                                    <a href="">{this.state.mail}</a>
                                </div>
                            </div>

                            <div className="hc-footer-contact">
                                <div className="icon"><i className="icofont-support"></i></div>
                                <div>
                                    <span className="label">Điện thoại</span>
                                    <a href={"tel:"+this.state.sdt}>{this.state.sdt}</a>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="hc-footer-bottom">
                        <div className="copyright">
                            &copy; Developed by <a href="https://www.facebook.com/julanove/" target="_blank" rel="noreferrer">Juchan</a>
                        </div>
                        <a className="hc-backtop js-scroll-trigger" href="#top">
                            <i className="icofont-long-arrow-up"></i>
                        </a>
                    </div>
                </div>
            </footer>
        );
    }
}

export default Footer;